<mat-card class="daxa-card date-range-calendar-container mb-25 border-radius bg-white d-block">
  <div class="d-flex">
    <div class="calendar">
      <mat-calendar
        [selected]="dateRange"
        [maxDate]="maxDate"
        [startAt]="dateRange.end"
        (selectedChange)="onSelectedChange($event)"
      />
    </div>
    <div class="predefined-list">
      @for (item of preDefinedDates; track item) {
        <button (click)="onPreDefinedDateSelect(item)" mat-flat-button color="primary">{{ item.label }}</button>
      }
    </div>
  </div>
</mat-card>
